import {faTimes} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Overlay, Content, Portal, Close} from '@radix-ui/react-dialog';
import clsx from 'clsx';

// TODO: animation on mobile should be different
// https://tailwindui.com/components/application-ui/overlays/dialogs#component-59de83fb9967d23dbf810d493d3f9a7b

type Props = React.HTMLAttributes<HTMLDivElement> & {
  children: React.ReactNode;
};
export const DialogContent = ({
  ref: forwardedRef,
  children,
  className,
  ...props
}: Props & {
  ref?: React.RefObject<HTMLDivElement>;
}) => {
  return (
    <Portal>
      <Overlay className="data-[state=closed]:animate-overlay-fade-out data-[state=open]:animate-overlay-fade-in fixed inset-0 z-30 bg-black/70">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <Content
            {...props}
            ref={forwardedRef}
            className={clsx(
              'bg-slate1 data-[state=closed]:animate-overlay-content-transform-out data-[state=open]:animate-overlay-content-transform-in dark:outline-slate6 relative max-h-[calc(100vh-2rem)] transform overflow-x-hidden overflow-y-auto rounded-lg px-4 pt-5 pb-4 text-left shadow-xl sm:my-8 sm:max-h-[calc(100vh-4rem)] sm:w-full sm:max-w-lg sm:p-6 dark:outline-1 dark:outline-solid',
              className
            )}
          >
            <div className="absolute top-0 right-0 hidden pt-4 pr-4 sm:block">
              <Close
                type="button"
                className="bg-slate1 text-slate9 hover:text-slate12 focus-visible:text-slate11 h-6 rounded-md focus-visible:outline-hidden"
              >
                <span className="sr-only">Close</span>
                <FontAwesomeIcon
                  icon={faTimes}
                  className="h-6 w-6"
                  aria-hidden="true"
                />
              </Close>
            </div>

            <div className="space-y-4 text-center sm:flex sm:grow sm:flex-wrap sm:items-start sm:gap-4 sm:space-y-0 sm:text-left">
              {children}
            </div>
          </Content>
        </div>
      </Overlay>
    </Portal>
  );
};

DialogContent.displayName = 'DialogContent';
